import {memo, ReactNode} from 'react';

import styled from 'styled-components';

import Button from '~/shared/components/Button';
import {smallRegular} from '~/shared/theme/typography';

import ChevronLeft from './assets/chevronLeft.svg?react';

const Root = styled(Button)<{withBorderTop?: boolean}>`
  ${({withBorderTop}) => withBorderTop && 'border-top: 1px solid rgba(0, 0, 0, 0.08);'}
  display: flex;
  justify-content: space-between;
  padding: 20px 0;

  :hover {
    background-color: ${({theme}) => theme.colors.actionWhiteHover};
  }
`;

const Caption = styled.span`
  ${smallRegular}
  color: ${({theme}) => theme.colors.contentDefault};
`;

type ActionButtonProps = {
  caption: ReactNode;
  onClick?: () => void;
  className?: string;
  withBorderTop?: boolean;
};

const ActionButton = ({caption, onClick, className, withBorderTop}: ActionButtonProps) => {
  return (
    <Root className={className} onClick={onClick} withBorderTop={withBorderTop}>
      <Caption>{caption}</Caption>
      <ChevronLeft />
    </Root>
  );
};

export default memo(ActionButton);
